import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export function clientRequestFollowersReducer(state = initialState.clientFollowersRelatedTasks, action) {
	switch (action.type) {
		case types.GET_FOLLOWERS_AND_RELATED_TASK: {
			let objectCopy = {
				...state,
				followersReadModel: action?.response?.followersReadModel,
				relatedTasksReadModel: action?.response.relatedTasksReadModel
				//silentRefresh: false
			};
			return objectCopy;
		}
		case types.CREATE_CLIENT_REQUEST_RELATED_TASK: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				let presentState = _.cloneDeep(state);
				if (action?.response && presentState?.relatedTasksReadModel) {
					presentState?.relatedTasksReadModel.push({
						...action.response,
						clientRequestId: action?.meta?.clientRequestId
					});
					presentState.silentRefresh = true;
					return presentState;
				}
			}
			return state;
		}
		case types.DELETE_CLIENT_REQUEST_RELATED_TASK: {
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				let presentState = _.cloneDeep(state);
				if (Object.keys(presentState).length > 0 && action.meta?.relatedTaskId) {
					const relatedTaskIndex = presentState?.relatedTasksReadModel.findIndex(
						(relatedTask) =>
							relatedTask.taskId === action.meta?.relatedTaskId &&
							relatedTask.clientRequestId === action.meta?.clientRequestId
					);
					if (relatedTaskIndex > -1) {
						presentState.relatedTasksReadModel.splice(relatedTaskIndex, 1);
						presentState.silentRefresh = true;
					}
					return presentState;
				}
			}
			return state;
		}
		case types.ADD_EY_CONTACT: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				let presentState = _.cloneDeep(state);
				if (action?.response && presentState?.followersReadModel) {
					var followersObjectStructure = {
						clientRequestFollowedByID: action.response.id,
						clientRequestId: action?.clientRequestId,
						createDate: '',
						firstName: null,
						followedByUserId: action.response.followedByUserId,
						isRetry: false,
						isViewed: false,
						lastName: null,
						modifyDate: null,
						syncStatusId: null,
						versionNumber: 0
					};
					let objectCopy = {
						...state,
						followersReadModel: [...state.followersReadModel, followersObjectStructure]
					};
					return objectCopy;
				}
			}
			return state;
		}
		case types.DELETE_EY_CONTACT: {
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				let presentState = _.cloneDeep(state);
				const deleteEyContacts = presentState?.followersReadModel?.findIndex(
					(contacts) =>
						contacts.clientRequestId === action.clientRequestId && contacts.followedByUserId === action.contactUserId
				);
				if (deleteEyContacts > -1) {
					presentState.followersReadModel.splice(deleteEyContacts, 1);
				}
				return presentState;
			}
			return state;
		}
		case types.SET_SILENT_REFRESH_FLAG: {
			return {
				...state,
				silentRefresh: false
			};
		}

		default:
			return state;
	}
}
